import { Component, inject, OnInit } from '@angular/core';
import { RouterLink } from '@angular/router';
import { Seo } from '../../core/seo';
import { breadcrumbLd } from '../../core/structured-data';
import { EQUIPMENT, STAGES, EquipmentItem } from '../../data/equipment';
import { Reveal } from '../../shared/reveal';

@Component({
  selector: 'app-equipment-list',
  imports: [RouterLink, Reveal],
  templateUrl: './equipment-list.html',
  styleUrl: './equipment.scss'
})
export class EquipmentList implements OnInit {
  private readonly seo = inject(Seo);

  readonly groups: Array<{ title: string; items: EquipmentItem[] }> = STAGES
    .map(s => ({ title: s.title, items: EQUIPMENT.filter(e => e.stage === s.key) }))
    .filter(g => g.items.length > 0);

  ngOnInit(): void {
    this.seo.apply({
      title: 'Water Treatment Equipment We Manufacture | Mechtron Water Services',
      description:
        'Oil skimmers, DAF, CPI separators, clarifiers, surface aerators, static mixers, filters ' +
        'and complete STP/ETP plants — designed and built in-house in Vasai Virar, Maharashtra.',
      path: '/equipment'
    });
    this.seo.setJsonLd('ld-breadcrumb', breadcrumbLd([
      { name: 'Home', path: '/' },
      { name: 'Equipment', path: '/equipment' }
    ]));
  }
}
